<template>
  <div class="visit-register">
    <div class="visit-register-header">
      <div class="logo-2">
        <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
      </div>
      <div class="reg-header">{{ $t('common.register')}}</div>
    </div>

    <div class="diff-user-type-main-content">
      <div class="reg-title">{{ getMsgTitle }}</div>
      <div class="reg-msg">{{ getMsgBody }}</div>
    </div>

    <p class="diff-user-type-main-content">
      {{ $t('preRegisteration.register_another_day')}}
    </p>

    <div class="yes-no-wrapper">
      <b-button @click="changeVisitDate()" class="change-date-btn activ-btn">
        {{ $t('preRegisteration.change_visit_date') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("preRegistration", [
      "getUserEntity",
      "getMsgTitle",
      "getMsgBody",
    ]),
  },
  methods: {
    ...mapActions("preRegistration", ["selectHasVisitedPage", "setSwitch"]),
    changeVisitDate() {
      this.$emit("changeTab");
      this.selectHasVisitedPage(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.visit-register {
  margin: auto;
  margin-top: 86px;
  margin-bottom: 86px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 491px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;

  //   header
  .visit-register-header {
    .logo-2 {
      display: block;
      width: 86px;
      height: 16px;
      margin: 46px auto 21px auto;
      img {
        width: 86px;
        height: 16px;
      }
    }
    .reg-header {
      font-family: "SF Pro Display";
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-transform: uppercase;
      text-align: center;

      color: #000000;
    }
  }

  .reg-title {
    width: 268px;
    margin: 92px auto 24px auto;
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .reg-msg {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto 68px auto;
    width: 403px;

    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666;
  }
  p.diff-user-type-main-content {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 27px !important;
    margin-bottom: 66px !important;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666 !important;
  }
  .yes-no-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 38px;
  }

  .change-date-btn {
    height: 44px;
    width: 415px;
    border-radius: 22px;
    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #ffffff;
    &:hover {
      background: #103f5e;
    }
  }
}

@media (max-width: 992px) {
  .visit-register {
    margin: auto;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 390px;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 0px;
    .visit-register-header {
      .logo-2 {
        display: block;
        width: 116px;
        height: 22px;
        margin: 73px auto 28px auto;
        img {
          width: 116px;
          height: 22px;
        }
      }
      .reg-header {
        font-family: "SF Pro Display";
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        text-transform: uppercase;
        color: #000000;
      }
    }

    .reg-title {
      width: 263px;
      margin: 136px auto 14px auto;
      font-weight: 500;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;

      color: #000000;
    }
    .reg-msg {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto 38px auto;
      width: 301px;
      font-weight: 400;
      font-size: 14px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
    }
    p.diff-user-type-main-content {
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 27px !important;
      margin: 0px auto 28px auto;
      text-align: center !important;
      letter-spacing: 0.25px !important;
      color: #666666 !important;
    }

    .yes-no-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 257px;
    }
    .change-date-btn {
      height: 37px;
      width: 309px;
      border-radius: 18.5px;
      font-weight: 500;
      font-size: 16px;
      line-height: 17px;
      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      color: #ffffff;
      &:hover {
        background: #103f5e;
      }
    }
  }
}
</style>
